import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReturnHebrewDatePipe } from 'src/app/Pipes/return-date-hebrew.pipe';
import { MaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MapComponent } from 'src/app/components/map/map.component';

@NgModule({
	declarations: [ReturnHebrewDatePipe, MapComponent],
	imports: [MaterialModule, CommonModule],
	exports: [ReturnHebrewDatePipe, MaterialModule, ReactiveFormsModule, MapComponent],
})
export class SharedModule {}
